<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";
import appConfig from "@/app.config";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: [
    "TabloId",
    "BirimId",
    "DonemId",
    "Sorgulama",
    "AltDonemId",
    "AllTable",
  ],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
        
      },
      izleme_formunda_aciklama_ciksin: appConfig.izleme_formunda_aciklama_ciksin,
      TabloVerileri: [],
      TabloDetayVerileri: [],

      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      Degerlendirme: null,
      donem_yili: "",
      deger: "",
      aciklama: "",
      bugun: null,
      hostname: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
      tumTablolar: false,
      AllTableData: [],
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId() {
      this.Get();
    },
  },

  methods: {
    Get() {
      this.bugun = new Date();
      this.TabloVerileri = [];
      this.TabloDetayVerileri = [];

      this.ActionsGet({
        Service: "StrPerfTablolarDetay",
        Page: this.Page,
      }).then((res1) => {
        this.gostergelistesi = res1.Data;

        this.ActionsGet({
          Service: "StrPerfDonem/" + this.AltDonemId,
          Page: this.Page,
        }).then((res2) => {
          this.donem_yili = res2.Data.BaslamaTarihi.slice(0, 4);

          let Filter =
            "&Tabloid=" +
            this.TabloId +
            "&Ustdonemid=" +
            this.DonemId +
            "&Donemid=" +
            this.AltDonemId +
            "&DonemAciklama=" +
            true;

          this.ActionsFilterGet({
            Service: "StrRaporlama/GetStratejikPlanIzlemeFormu",
            Page: this.Page,
            Filter: Filter,
          }).then((res3) => {
            this.TabloVerileri = res3.Data;
            this.TabloDetayVerileri = this.TabloVerileri.TabloDetay;

            let Filter2 =
              "&DonemId=" +
              this.AltDonemId +
              "&Tabloid=" +
              this.TabloId +
              "&isPerformansHedefi=true&isStrPlanDegerlendirme=true";
            if(this.BirimId!=null && this.BirimId!=""){
              Filter2=Filter2+"&Birimid="+this.BirimId;
            }
            this.ActionsFilterGet({
              Service: "StrRaporlama/GetStratejikPlanDegerlendirmeFormu",
              Page: this.Page,
              Filter: Filter2,
            }).then((res) => {
              this.Degerlendirme = res.Data.Degerlendirme;
            });
          });
        });
      });
    },

    get_tum_tablolar() {
      this.tumTablolar = !this.tumTablolar;
      this.AllTableData = [];
      let promises = [];
      for (var table in this.AllTable) {
        let Filter =
          "&Tabloid=" +
          this.AllTable[table].Id +
          "&Ustdonemid=" +
          this.DonemId +
          "&Donemid=" +
          this.AltDonemId;

        promises.push(
          this.ActionsFilterGet({
            Service: "StrRaporlama/GetStratejikPlanIzlemeFormu",
            Page: this.Page,
            Filter: Filter,
          }).then((res) => {
            this.AllTableData.push(res.Data);
          })
        );
      }

      Promise.all(promises).then(() => {
        this.AllTableData.sort((a, b) => a.SiraNo - b.SiraNo);
      });
    },

    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.Izlemetablosu;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
  },
  computed: {},

  created() {
    this.Get();
    this.hostname = this.$config.COOKIES_DOMAIN;
  },
};
</script>
<template>
  <div>
    <div>
      <div class="text-sm-end">
      
        <button
          type="button"
          class="btn btn-primary btn-rounded mb-2 me-2"
          @click="get_tum_tablolar()"
          v-if="tumTablolar == false"
        >
          Tüm Tablolar İçin Getir
        </button>
        <button
          type="button"
          class="btn btn-warning btn-rounded mb-2 me-2"
          @click="get_tum_tablolar()"
          v-if="tumTablolar == true"
        >
          Seçili Tablo İçin Getir
        </button>
        <button
          type="button"
          class="btn btn-success btn-rounded mb-2 me-2"
          @click="ExcelExport('İzleme Tablosu', 'İzleme Tablosu')"
        >
          <i class="mdi mdi-file-export-outline me-1"></i>
          Excel'e Aktar
        </button>
         <button
          type="button"
          class="btn btn-success btn-rounded mb-2 me-2"
          @click="Export2Word('exportContent', 'İzleme Tablosu')"
        >
          <i class="mdi mdi-file-export-outline me-1"></i>
          Word'e Aktar
        </button>
      </div>

      <div id="exportContent" ref="Izlemetablosu" v-if="tumTablolar == false">
        <table class="col-md-12">
          <tbody>
            <tr>
              <td>
                <div>
                  <table
                    style="border: 1px solid; border-collapse: collapse;"
                    border="1"
                    class="table  table-md table-bordered border-success mb-0"
                  >
                    <tbody>
                      <tr>
                        <th
                          colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;font-weight:bold;text-align:center;"
                        >
                          Stratejik Plan İzleme Tablosu
                        </th>
                      </tr>
                    </tbody>
                     <tbody>
                                         <tr>
                        <td
                          style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;"
                          scope="col"
                          colspan="1"
                        >
                          {{ $t("IzlemeTablosu.Table.Amac") }}
                        </td>
                        <td colspan="5">
                          {{ TabloVerileri.Amac }}
                        </td>
                      </tr>
                    </tbody>
                          <tbody>

                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;"
                          scope="col"
                          colspan="1"
                        >
                          {{ $t("IzlemeTablosu.Table.TabloAdi") }}
                        </td>
                        <td colspan="5">{{ TabloVerileri.Hedef }}</td>
                      </tr>

                                </tbody>
                                    <tbody>

         <tr v-if="TabloVerileri.Programad != ''">
                        <td
                          style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;"
                          scope="col"
                          colspan="1"
                        >
                          {{ $t("StrPerfTablo.AddEdit.Programad") }}
                        </td>
                        <td colspan="5">{{ TabloVerileri.Programad }}</td>
                      </tr>
                                        </tbody>
                                           <tbody>
       <tr v-if="TabloVerileri.Programhedef != ''">
                        <td
                          style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;"
                          scope="col"
                          colspan="1"
                        >
                          {{ $t("StrPerfTablo.AddEdit.Programhedef") }}
                        </td>
                        <td colspan="5">{{ TabloVerileri.Programhedef }}</td>
                      </tr>

                                              </tbody>
                                                <tbody>
                                                  <tr>
                        <td
                          style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;"
                          scope="col"
                          colspan="1"
                        >
                          {{ $t("IzlemeTablosu.Table.PerformansHedefi") }}
                        </td>
                        <td colspan="5" style="text-align: left;">
                          {{
                            TabloVerileri.HedefPerformans | formatNoktaToVirgul
                          }}
                        </td>
                      </tr>

                                                  </tbody>
                    <tbody>

             
               
                    
                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;"
                          scope="col"
                          colspan="1"
                        >
                          {{ $t("IzlemeTablosu.Table.SorumluBirim") }}
                        </td>
                        <td colspan="5">{{ TabloVerileri.SorumluBirimAdi }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="table-responsive">
                  <table
                    style="border: 1px solid; border-collapse: collapse;"
                    border="1"
                    class="table table-md table-bordered border-success mb-0"
                  >
                    <tbody>
                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Göstergesi
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Hedef Etkisi
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Başlangıç Değeri
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          {{ TabloVerileri.HedefDonem }}
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          {{ TabloVerileri.GerceklesmeDonem }}
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Performans
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <template
                        v-for="(TabloDetay, index) in TabloDetayVerileri"
                      >
                        <tr :key="index">
                          <td>{{ TabloDetay.Gostergesi }}</td>
                          <td>{{ TabloDetay.HedefEtkisi }}</td>
                          <td>
                            {{
                              TabloDetay.BaslangicDeger | formatNoktaToVirgul
                            }}
                          </td>
                          <td>{{ TabloDetay.Hedef | formatNoktaToVirgul }}</td>
                          <td>
                            {{ TabloDetay.Gerceklesme | formatNoktaToVirgul }}
                          </td>
                          <td
                            v-if="
                              TabloVerileri.IzlemeRaporPerformansYuzdeConfig ==
                                false
                            "
                          >
                            {{ TabloDetay.Performans | formatNoktaToVirgul }}
                          </td>
                          <td
                            v-if="
                              TabloVerileri.IzlemeRaporPerformansYuzdeConfig ==
                                true
                            "
                          >
                            %
                            {{
                              TabloDetay.PerformansYuzde | formatNoktaToVirgul
                            }}
                          </td>
                        </tr>
                        <tr :key="index"  v-if="izleme_formunda_aciklama_ciksin==true">
                          <td>Açıklama</td>
                          <td colspan="5">{{TabloDetay.Aciklama}}</td></tr>
                      </template>
                    </tbody>
                    <tbody>
                      <tr>
                        <td
                          colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;text-align: center"
                        >
                          Hedefe İlişkin Değerlendirmeler
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="6"
                          style="background-color:white; justify-content: space-between;"
                          v-html="Degerlendirme"
                        ></td>
                      </tr>
                    </tbody>
                  </table>
                  <table></table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>

      <div
        ref="Izlemetablosu"
        class="table-responsive"
        v-if="tumTablolar == true"
      >
        <table
          class="col-md-12"
          v-for="(TabloVerileri, index) in AllTableData"
          :key="index"
        >
          <tbody>
            <tr>
              <td>
                <div class="table-responsive">
                  <table
                    style="border: 1px solid; border-collapse: collapse;"
                    border="1"
                    class="table table-md table-bordered border-success mb-0"
                  >
                    <tbody>
                      <tr>
                        <th
                          colspan="7"
                          style="background-color:rgb(7, 156, 165);color:white;text-align:center;"
                        >
                          Stratejik Plan İzleme Tablosu
                        </th>
                      </tr>
                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                          scope="col"
                        >
                          {{ $t("IzlemeTablosu.Table.Amac") }}
                        </td>
                        <td
                          colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;"
                        >
                          {{ TabloVerileri.Amac }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                          scope="col"
                        >
                          {{ $t("IzlemeTablosu.Table.TabloAdi") }}
                        </td>
                        <td
                          colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;"
                        >
                          {{ TabloVerileri.Hedef }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                          scope="col"
                        >
                          {{ $t("IzlemeTablosu.Table.PerformansHedefi") }}
                        </td>
                        <td
                          colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;text-align: left;"
                        >
                          {{
                            TabloVerileri.HedefPerformans | formatNoktaToVirgul
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                          scope="col"
                        >
                          {{ $t("IzlemeTablosu.Table.SorumluBirim") }}
                        </td>
                        <td
                          colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;"
                        >
                          {{ TabloVerileri.SorumluBirimAdi }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="table-responsive">
                  <table
                    style="border: 1px solid; border-collapse: collapse;"
                    border="1"
                    class="table table-md table-bordered border-success mb-0"
                  >
                    <thead>
                      <tr>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Göstergesi
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Gösterge Tipi
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Hedef Etkisi
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Başlangıç Değeri
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          {{ TabloVerileri.HedefDonem }}
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          {{ TabloVerileri.GerceklesmeDonem }}
                        </td>
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Performans
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="(TabloDetay, index) in TabloVerileri.TabloDetay"
                      >
                        <tr :key="index">
                          <td>{{ TabloDetay.Gostergesi }}</td>
                          <td>{{ TabloDetay.GostergeTipi }}</td>
                          <td>{{ TabloDetay.HedefEtkisi }}</td>
                          <td>
                            {{
                              TabloDetay.BaslangicDeger | formatNoktaToVirgul
                            }}
                          </td>
                          <td>{{ TabloDetay.Hedef | formatNoktaToVirgul }}</td>
                          <td>
                            {{ TabloDetay.Gerceklesme | formatNoktaToVirgul }}
                          </td>
                          <td
                            v-if="
                              TabloVerileri.IzlemeRaporPerformansYuzdeConfig ==
                                false
                            "
                          >
                            {{ TabloDetay.Performans | formatNoktaToVirgul }}
                          </td>
                          <td
                            v-if="
                              TabloVerileri.IzlemeRaporPerformansYuzdeConfig ==
                                true
                            "
                          >
                            %
                            {{
                              TabloDetay.PerformansYuzde | formatNoktaToVirgul
                            }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr :key="index">
                        <td
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;"
                        >
                          Açıklama
                        </td>
                        <td
                          colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;"
                        >
                          {{ TabloDetay.Aciklama }}
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
    </div>
  </div>
</template>
